export const APP_DOWNLOAD_URL = 'https://nospen.lt/dl';
export const IOS_APP_STORE_URL =
  'https://apps.apple.com/lt/app/nospen/id6752844714';
export const GOOGLE_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.nospen';
